import { render, staticRenderFns } from "./BankSkeleton.vue?vue&type=template&id=1f924dce&scoped=true&"
import script from "./BankSkeleton.vue?vue&type=script&lang=js&"
export * from "./BankSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./BankSkeleton.vue?vue&type=style&index=0&id=1f924dce&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f924dce",
  null
  
)

export default component.exports